import loadableVisibility from 'react-loadable-visibility/loadable-components';
import React from 'react';
import BelowTheFold from 'shared/components/BelowTheFoldControl';

const Loadable = loadableVisibility(
  () => import(/* webpackChunkName: "MyProfile.lazy" */ './Loadable'),
  {
    fallback: <></>,
  }
);

const ServerOptimized = () => (
  <BelowTheFold
    render={Loadable}
    loading={() => <></>}
  />
);

export default ServerOptimized;
